import { create } from 'zustand';

export const useBlockModelDataStore = create((set, get) => ({
  byKey: {},
  setPacked: (name, packed, meta = {}) => {
    if (!name) return;
    set((state) => ({
      byKey: {
        ...state.byKey,
        [name]: { name, packed, meta, updatedAt: Date.now() },
      },
    }));
  },
  clearPacked: (name) => {
    if (!name) return;
    set((state) => {
      if (!state.byKey[name]) return state;
      const next = { ...state.byKey };
      delete next[name];
      return { byKey: next };
    });
  },
  list: () => Object.values(get().byKey),
}));
